import {KnowledgeDto} from './knowledge-dto';

export class KnowledgeTopicDto {

  public id: number;

  public name: string;

  public knowledge: KnowledgeDto | undefined;

  constructor(id: number, name: string, knowledge: KnowledgeDto | undefined) {
    this.id = id;
    this.name = name;
    this.knowledge = knowledge;
  }
}
